import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardVisitorComponent } from "./components/dashboard-visitor.component";
import { AuthguardService } from "../master/services";

export const DashboardVisitorRoutes: Routes = [
	{
		path: "",
		data: {
			title: "Dashboard (Visitor)",
			applicationItemID: "5ea64e13-23e0-4275-8db3-147b1d1a3298",
		},
		component: DashboardVisitorComponent,
		// canActivate: [AuthguardService],
	},
];
